import Api from "clients/helpers/api";

import { SearchResponse } from "./types";

export async function search(query: string): Promise<SearchResponse> {
  return Api.get("/content/search", { query }) as Promise<SearchResponse>;
}
